module.exports = __webpack_public_path__ + "img/badge-list-thumb-046.e107f2eb.png";